import { action, atom } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { pipe, Result } from '@blade/std-lib'
import { authStateAtom } from '@root/entities/auth'
import { STORAGE_PREFIX } from '@root/shared'
import { ApiError, apiRequest } from '@root/shared/api'
import { tradeApiClientAtom } from '@root/shared/api/trade-api-client-atom'

import { Network } from '../model'

export const changeNetworkRequestAction = action(
  async (ctx, network: Network.Network) => {
    const { tradeApiClient } = ctx.get(tradeApiClientAtom)

    return pipe(
      await ctx.schedule(() =>
        apiRequest(ctx, tradeApiClient.user.userChangeNetworkCreate, [
          {
            network: Network.toDto(network),
          },
        ]),
      ),
      Result.map(() => undefined),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'changeNetworkRequestAction',
)

const STORAGE_KEY = `${STORAGE_PREFIX}/v1/selectedNetwork`
export const selectedNetworkAtom = atom<Network.Network>(
  Network.Solana,
  'selectedNetworkAtom',
).pipe(withLocalStorage(STORAGE_KEY))

export const setNetworkAction = action(
  (ctx, network: Network.Network, skipSync: boolean = false) => {
    selectedNetworkAtom(ctx, network)

    if (skipSync) {
      return
    }

    const authState = ctx.get(authStateAtom)
    if (authState.type !== 'LoggedIn') {
      return
    }

    changeNetworkRequestAction(ctx, network)
  },
  'setNetworkAction',
)

export * from './reatom-network-data'
export * from './network-data-requests'
export * from './reatom-fee-config'
